import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseProduct() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validateLvl1(state, setter, callBack) {
    let errorState = {
      faName: isEmpty(state.faName),
      enName: isEmpty(state.enName),
      brandID: isEmpty(state.brandID),
      categoryID: isEmpty(state.categoryID),
      countryID: isEmpty(state.countryID),
      companyID: isEmpty(state.companyID),
    };

    setter(errorState);

    if (
      errorState.faName ||
      errorState.enName ||
      errorState.brandID ||
      errorState.categoryID ||
      errorState.countryID ||
      errorState.companyID
    ) {
      enqueueSnackbar("لطفا اطلاعات محصول را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      callBack(500);
    } else {
      let newState = {
        faName: state.faName,
        enName: state.enName,
      };
      validateLvl1Names(newState, (resault) => {
        callBack(resault);
      });
    }
  }

  function validateLvl1Edit(state, setter, callBack, setFire) {
    let errorState = {
      faName: isEmpty(state.faName),
      enName: isEmpty(state.enName),
      brandID: isEmpty(state.brandID),
      categoryID: isEmpty(state.categoryID),
      countryID: isEmpty(state.countryID),
      companyID: isEmpty(state.companyID),
    };

    setter(errorState);

    if (
      errorState.faName ||
      errorState.enName ||
      errorState.brandID ||
      errorState.categoryID ||
      errorState.countryID ||
      errorState.companyID
    ) {
      enqueueSnackbar("لطفا اطلاعات مرحله اول را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      setFire(false);
      return 500;
    } else {
      let newState = {
        id: state.id,
        faName: state.faName,
      };
      validateLvl1Names(newState, (resault) => {
        callBack(resault);
      });
    }
  }

  function validateLvl2Edit(state, setter, callBack, setFire) {
    let errorState = {
      typeID: isEmpty(state.typeID),
      weight: isEmpty(state.weight),
    };
    setter(errorState);
    if (errorState.typeID || errorState.weight) {
      enqueueSnackbar("لطفا وزن و نوع محصول را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      if (setFire) {
        setFire(false);
      }
      return 500;
    } else {
      callBack();
    }
  }

  function validateLvl3Edit(state, setter, callBack, setFire) {
    let errorState = {
      gender: isEmpty(state.gender),
    };
    if (state.gender == 0) {
      errorState.gender = false;
    }
    setter(errorState);
    if (errorState.gender) {
      enqueueSnackbar("لطفا جنسیت را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      if (setFire) {
        setFire(false);
      }
      return 500;
    } else {
      callBack();
    }
  }

  function validateLvl4Edit(state, setter, callBack, setFire) {
    let errorState = {
      groupID: isEmpty(state.groupID),
    };
    setter(errorState);
    if (errorState.groupID) {
      enqueueSnackbar("لطفا گروه محصول را انتخاب کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      if (setFire) {
        setFire(false);
      }
      return 500;
    } else {
      callBack();
    }
  }

  function validateLvl1Names(state, callBack) {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Products/ValidateProduct`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callBack(200);
      }
    });
  }

  const getProductListSlave = (myPC, search, callback) => {
    if (search.length > 0) {
      MyAxios.get(`Admin_Products?w=${search}`, {
        headers: {
          Conditions: JSON.stringify({ pageCondition: myPC }),
        },
      }).then((response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      });
    }
  };

  const getProducList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Products?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const GetProductsByWord = (Word, callback) => {
    MyAxios.get(`Admin_Products/GetProductsByWord?w=${Word}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const ResetCache = (id, callback) => {
    MyAxios.get(`Admin_Products/ResetCache/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کش با موفقیت به‌روزرسانی شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const getProductByID = (id, callback) => {
    MyAxios.get(`Admin_Products/${id}`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
            searchText: "",
            scrollTo: undefined,
            forceRefresh: false,
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const removeIngIDs = (product) => {
    let newIng =
      product.ingredients &&
      product.ingredients.map((test) => {
        if (test.IsNewIg) {
          delete test.id;
          delete test.IsNewIg;
        }
        return test;
      });
    product.ingredients = newIng;
    return product;
  };

  const generateIngID = (product, ing) => {
    let id = Math.max(...product.ingredients.map((o) => o.id), 0);
    let orderRow = Math.max(...product.ingredients.map((o) => o.orderRow), 0);
    ing.id = id + 1;
    ing.orderRow = orderRow + 1;
    ing.IsNewIg = true;
    return ing;
  };

  const updateProduct = (state, callback, setFireGetData) => {
    state = removeIngIDs(state);
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.put(`Admin_Products`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محصول با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      } else {
        setFireGetData(false);
        return;
      }
    });
  };

  const addProduct = (state, callback, setFireGetData) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Products`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محصول با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      } else {
        setFireGetData(false);
        return;
      }
    });
  };

  const CloneProduct = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Products/CloneProduct`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محصول با موفقیت ایجاد شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deleteProduct = (id, callback) => {
    const data = new FormData();
    data.append("ProductID", id);
    MyAxios.delete(`Admin_Products`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محصول با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const generateListID = (list) => {
    let orderRow = Math.max(...list.map((o) => o.orderRow), 0);
    return orderRow + 1;
  };

  const lastOrderRow = (list) => {
    var lastOrderRow = Math.max.apply(
      Math,
      list.map(function (o) {
        return o.orderRow;
      })
    );
    let orderRow = lastOrderRow != -Infinity ? lastOrderRow + 1 : 1;
    return orderRow;
  };

  const isExsit = (state, id) => {
    return state.find((model) => model.id == id);
  };

  return {
    validateLvl1Edit,
    validateLvl2Edit,
    validateLvl3Edit,
    validateLvl4Edit,
    getProducList,
    getProductByID,
    validateLvl1,
    updateProduct,
    addProduct,
    deleteProduct,
    getProductListSlave,
    removeIngIDs,
    generateIngID,
    generateListID,
    GetProductsByWord,
    CloneProduct,
    isExsit,
    lastOrderRow,
    ResetCache,
  };
}
